// Zeitlimit-Warnung über der Timeline eines Flex-Assets (Multi-Lingual ohne
// Video): `targetDuration` ist dort nur ein Richtwert, die Pill blockt nichts.
// Eine Komponente für TTS- und STS-View — vorher stand dasselbe JSX samt CSS
// in beiden Views (Review 2026-09-21). Die Views liefern nur ihre Chips:
// TTS aus den favorisierten Takes, STS aus den Master-Clips.
import { overLimit } from '@/lib/overLimit';
import styles from './OverLimitPill.module.css';

interface Props {
  chips: { offset: number; dur: number }[];
  /** Admin-Zeitlimit in Sekunden; ohne Limit rendert die Pill nichts. */
  limitSec: number | null | undefined;
}

export function OverLimitPill({ chips, limitSec }: Props) {
  const lim = overLimit(chips, limitSec);
  if (!lim.over) return null;
  return (
    <div className={styles.pill} role="alert">
      <i className="ph-bold ph-warning" /> Over time limit —{' '}
      {lim.endSec.toFixed(1)}s / {limitSec}s
    </div>
  );
}
